import { render, staticRenderFns } from "./QuizFinishScreenForm.vue?vue&type=template&id=290b0fb0&"
import script from "./QuizFinishScreenForm.vue?vue&type=script&lang=ts&"
export * from "./QuizFinishScreenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports